<div class="row" [style]="'height: ' + chartHeight + 'vh;'">
    <canvas baseChart
        [data]="chartData"
        [type]="chartConfig.type === 'line' ? 'line' : 'line'"
        [options]="chartOptions">
    </canvas>
</div>

